import { useSearchParams } from "react-router-dom";
import { assetAllocationPages } from "@app/const/route.const";
import { ModuleScenarioAnalysisReport } from "@app/pages/portfolioAnalysis/pdfScenarioAnalysisReport/ModuleScenarioAnalysisReport";

export const PdfAssetAllocationModuleScenarioAnalysisReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, dataIds } =
    assetAllocationPages.getPdfModuleScenarioAnalysisReportParams(searchParams);

  return (
    <ModuleScenarioAnalysisReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      dataIds={dataIds}
      footer="Asset Allocation"
    />
  );
};
